<div class="message-dialog">
    @if (shouldCloseLinkBeDisplayed) {
        <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
        <a class="theme-ex" tabindex="0" (click)="closeLinkClickHandler()" (keydown)="closeLinkClickHandler()"></a>
    }
    <h3 class="{{ contentData.type }}" id="title">{{ contentData.title }}</h3>

    <div class="content">
        <p id="first_paragraph" [innerHTML]="contentData.firstParagraph"></p>
        <p id="second_paragraph" [innerHTML]="contentData.secondParagraph"></p>

        @if (isDesignSystem) {
            <div class="message-dialog__buttons">
                @for (button of contentData.buttons; track $index) {
                    <button
                        class="buttons_message-dialog_buttons"
                        ds-button
                        truncate="true"
                        [class]="{ 'single-button': contentData.buttons?.length === 1 }"
                        [kind]="button.buttonConfig!.kind"
                        [variant]="button.buttonConfig!.variant"
                        [size]="button.buttonConfig!.size"
                        (click)="buttonClickHandler(button)">
                        {{ button.text }}
                    </button>
                }
            </div>
        } @else {
            <div class="buttons">
                @for (button of contentData.buttons; track $index) {
                    <button class="btn {{ button.cssClass || 'continue btn-primary' }}" (click)="buttonClickHandler(button)">
                        {{ button.text }}
                    </button>
                }
            </div>
        }
    </div>
</div>
